import React, { useEffect } from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import CustomTabBar from "../components/BottomBar/CustomTabBar";
import HomeFeed from "../screens/HomeFeed/HomeFeed";
import AllExperience from "../screens/ExeperienceScreens/Experience/AllExperience";
import Experience from "../screens/ExeperienceScreens/Experience/Experience";
import Interests from "../screens/Interests/Interests";
import Matches from "../screens/Chat/Matches";
import UserProfile from "../screens/UserProfile/ProfileScreens/UserProfile/UserProfile";
import EditProfile from "../screens/UserProfile/ProfileScreens/EditProfile/EditProfile";
import EditExperience from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditExperience";
import EditName from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditName";
import EditGender from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditGender";
import EditBody from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditBody";
import EditWorkplace from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditWorkplace";
import EditJobTitle from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditJobTitle";
import EditSchool from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditSchool";
import EditSeeking from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditSeeking";
import EditRelationship from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditRelationship";
import EditDrinking from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditDrinking";
import EditSmoking from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditSmoking";
import PauseAccount from "../modal/UserProfileModals/PauseAccount";
import EditHeight from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditHeight";
import EditLanguage from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditLanguage";
import Ethnicity from "../screens/UserProfile/ProfileScreens/EditProfile/EditScreens/EditEthnicity";
import UserProfileSettings from "../screens/UserProfile/Settings/UserProfileSettings";
import Bookings from "../screens/ExeperienceScreens/Bookings/Bookings";
import BookingDetails from "../screens/ExeperienceScreens/Bookings/BookingDetails";
import { Linking } from "react-native";
import * as Location from "expo-location";
import { updateDataImage } from "../services/Profile/profileService";
import { getCity } from "../services/ProfileSettings/ProfileSettingService";
import { setLocation } from "../redux/auth/authSlice";
import { dispatch } from "../redux/store";
// import Interests from "../screens/Interests/Interestss";
const Stack = createNativeStackNavigator();
const Tab = createBottomTabNavigator();

function HomeTabs({ navigation, route }: { navigation: any; route: any }) {

  useEffect(()=>{
    const handleGrantLocation = async()=>{
      let location = await Location.getCurrentPositionAsync({});
      if(location){
        const loc = await getCity(location.coords.latitude, location.coords.longitude)
        dispatch(setLocation(`${loc.results[0].components.city}, ${loc.results[0].components.country}`))
        updateDataImage({
          userInfo: {
            geolocation: {
              latitude: location.coords.latitude,
              longitude: location.coords.longitude,
            },
          },
        });
      }
    }
    
    handleGrantLocation()
  },[])

  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
      }}
      tabBar={(props) => <CustomTabBar {...props} />}
      initialRouteName='Discover'
    >
      <Tab.Screen name="HomeFeed" component={HomeFeed} />
      <Tab.Screen name="Discover" component={AllExperience} />
      <Tab.Screen name="Interests" component={Interests} />
      <Tab.Screen name="Matches" component={Matches} />
      <Tab.Screen name="Profile" component={UserProfile} />
    </Tab.Navigator>
  );
}

const RootNavigation = () => {
  return (
    <>
      <Stack.Navigator>
        <Stack.Screen
          name="Home"
          options={{
            headerShown: false,
          }}
        >
          {(props) => <HomeTabs {...props} />}
        </Stack.Screen>
        <Stack.Screen
          name="experience"
          component={Experience}
          options={{
            headerShown: false,
            animation: 'slide_from_right'
          }}
        />

        <Stack.Screen
          name="EditProfile"
          component={EditProfile}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="edit-experience"
          component={EditExperience}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="edit-name"
          component={EditName}
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="edit-gender"
          component={EditGender}
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="body-edit"
          component={EditBody}
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="edit-workplace"
          component={EditWorkplace}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="edit-jobtitle"
          component={EditJobTitle}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="edit-school"
          component={EditSchool}
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="edit-seeking"
          component={EditSeeking}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="edit-relationship"
          component={EditRelationship}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="edit-drinking"
          component={EditDrinking}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="edit-smoking"
          component={EditSmoking}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="edit-height"
          component={EditHeight}
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="edit-language"
          component={EditLanguage}
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="ethnicity"
          component={Ethnicity}
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="settings-main"
          component={UserProfileSettings}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="bookings"
          component={Bookings}
          options={{
            headerShown: false,
          }}
        />

        <Stack.Screen
          name="booking-details"
          component={BookingDetails}
          options={{
            headerShown: false,
          }}
        />
      </Stack.Navigator>
    </>
  );
};
export default RootNavigation;
